__turbopack_context__.v({
  "image": "image-slide-module-scss-module__v8DiXq__image",
  "placeholder": "image-slide-module-scss-module__v8DiXq__placeholder",
  "slide": "image-slide-module-scss-module__v8DiXq__slide",
});
